import { FC } from 'react';
import { UserRow } from '../types';
import { Button, ButtonSizes, ButtonStyles, Icons } from '@silverfort/sf-components';
import { useUserDrawer } from '../../../hooks/useUserDrawer';

type Props = UserRow;

const ManageCell: FC<Props> = ({ id: userId }) => {
    const { openUserDrawer } = useUserDrawer();

    const handleClick = () => {
        openUserDrawer(userId);
    };

    return (
        <div className="flex justify-end">
            <Button
                className="opacity-0 group-hover:opacity-100"
                iconRight={Icons.Settings}
                onClick={handleClick}
                buttonStyle={ButtonStyles.GhostSolid}
                buttonSize={ButtonSizes.Small}
            />
        </div>
    );
};

export default ManageCell;
